import { Component } from '@angular/core';

@Component({
  selector: 'app-hphtrheology-vertical-header',
  standalone: false,
  templateUrl: './hphtrheology-vertical-header.component.html',
  styleUrl: '../../job-request-column-report.component.scss'
})
export class HphtrheologyVerticalHeaderComponent {

}
